import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userImprintOverviewsAdapter = createEntityAdapter({})

const initialState = userImprintOverviewsAdapter.getInitialState()

export const userImprintOverviewsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserImprintOverviews: builder.query({
            query: () => ({
                url: '/userImprintOverviews/getUserImprintOverviews',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserImprintOverviews = responseData.map(userImprintOverview => {
                    userImprintOverview.id = userImprintOverview._id
                    return userImprintOverview
                })
                return userImprintOverviewsAdapter.setAll(initialState, loadedUserImprintOverviews)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserImprintOverview', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserImprintOverview', id}))
                    ]
                } else {
                    return [ { type: 'UserImprintOverview', id: 'LIST'}]
                }
            },
        }),
        createNewUserImprintOverview: builder.mutation({
            query: initialUserImprintOverview => ({
                url: '/userImprintOverviews/createNewUserImprintOverview',
                method: 'POST',
                body: {...initialUserImprintOverview,}
            }),
            invalidatesTags: [
                { type: 'UserImprintOverview', id: "LIST" }
            ] 
        }),
        updateUserImprintOverview: builder.mutation({
            query: initialUserImprintOverview => ({
                url: '/userImprintOverviews/updateUserImprintOverview',
                method: 'PATCH',
                body: {...initialUserImprintOverview,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserImprintOverview', id: arg.id },
                { type: 'UserImprintOverview', id: 'LIST' }
            ],
        }),
        deleteUserImprintOverview: builder.mutation({
            query: ({id}) => ({
                url: '/userImprintOverviews/deleteUserImprintOverview',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserImprintOverview', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserImprintOverviewsQuery,
    useCreateNewUserImprintOverviewMutation,
    useUpdateUserImprintOverviewMutation,
    useDeleteUserImprintOverviewMutation,
} = userImprintOverviewsApiSlice

// returns the query result object
export const selectUserImprintOverviewResult = userImprintOverviewsApiSlice.endpoints.getUserImprintOverviews.select()

// create memoized selector
const selectUserImprintOverviewsData = createSelector(
    selectUserImprintOverviewResult,
    userImprintOverviewResult => userImprintOverviewResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserImprintOverviews,
    selectById: selectUserImprintOverviewById,
    selectIds: selectUserImprintOverviewIds,
} = userImprintOverviewsAdapter.getSelectors(state => selectUserImprintOverviewsData(state) ?? initialState)